import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AddIcon, SubtractIcon, Typography, getTestId } from '@airtel/air-design-system';
import { useEffect, useState } from 'react';
import { Pressable, View } from 'react-native';
import { getCounterVariantColor, getCounterWidgetStyles } from './CounterWidgetStyles';
export var CounterWidgetComponent = props => {
  var _props$size = props.size,
    size = _props$size === void 0 ? 'sm' : _props$size,
    _props$value = props.value,
    value = _props$value === void 0 ? '1' : _props$value,
    _props$minValue = props.minValue,
    minValue = _props$minValue === void 0 ? '1' : _props$minValue,
    _props$maxValue = props.maxValue,
    maxValue = _props$maxValue === void 0 ? Infinity : _props$maxValue,
    onDecrementButtonPressMetaData = props.onDecrementButtonPressMetaData,
    onIncrementButtonPressMetaData = props.onIncrementButtonPressMetaData,
    onUserAction = props.onUserAction,
    id = props.id,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'CounterWidget' : _props$testID,
    style = props.style,
    _props$decrementButto = props.decrementButtonAccessibilityProps,
    decrementButtonAccessibilityProps = _props$decrementButto === void 0 ? {} : _props$decrementButto,
    _props$incrementButto = props.incrementButtonAccessibilityProps,
    incrementButtonAccessibilityProps = _props$incrementButto === void 0 ? {} : _props$incrementButto;
  var colorTypes = getCounterVariantColor();
  var counterWidgetStyles = getCounterWidgetStyles(props);
  var _useState = useState(value),
    packCount = _useState[0],
    setPackCount = _useState[1];
  var _useState2 = useState(false),
    isIncrementDisabled = _useState2[0],
    setIsIncrementDisabled = _useState2[1];
  var _useState3 = useState(false),
    isDecrementDisabled = _useState3[0],
    setIsDecrementDisabled = _useState3[1];
  var modifyCountValue = num => {
    return num > 9 || num <= 0 ? '' + num : '0' + num;
  };
  useEffect(() => {
    setIsDecrementDisabled(+packCount <= +minValue);
    setIsIncrementDisabled(+packCount >= +maxValue);
  }, [packCount, minValue, maxValue]);
  var updateCount = operation => {
    setPackCount(prevCount => {
      var newCount = +prevCount;
      if (operation === 'decrement' && +prevCount > +minValue) {
        newCount--;
      }
      if (operation === 'increment' && +prevCount < +maxValue) {
        newCount++;
      }
      return newCount;
    });
  };
  return _jsxs(View, Object.assign({
    style: [counterWidgetStyles.counterContainer, style]
  }, getTestId(testID), {
    children: [_jsx(Pressable, Object.assign({
      testID: "decrement-press",
      style: [counterWidgetStyles.iconsContainer, Object.assign({}, isDecrementDisabled && counterWidgetStyles.disabledStyles)],
      disabled: isDecrementDisabled,
      onPress: () => {
        var newCount = +packCount - 1;
        if (newCount >= +minValue) {
          onDecrementButtonPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, onDecrementButtonPressMetaData), {
            item: props,
            currentValue: newCount
          }));
          updateCount('decrement');
        }
      }
    }, decrementButtonAccessibilityProps, {
      children: _jsx(SubtractIcon, {
        fontSize: size == 'sm' ? 14 : 18,
        color: isDecrementDisabled ? colorTypes.disabledIconColor : colorTypes.color
      })
    })), _jsx(Typography, {
      type: "body-single-line-sm",
      text: modifyCountValue(+packCount),
      color: colorTypes.text,
      style: counterWidgetStyles.countText,
      selectable: false
    }), _jsx(Pressable, Object.assign({
      testID: "increment-press",
      style: [counterWidgetStyles.iconsContainer, Object.assign({}, isIncrementDisabled && counterWidgetStyles.disabledStyles)],
      disabled: isIncrementDisabled,
      onPress: () => {
        var newCount = +packCount + 1;
        if (newCount <= +maxValue) {
          onIncrementButtonPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, onIncrementButtonPressMetaData), {
            item: props,
            currentValue: newCount
          }));
          updateCount('increment');
        }
      }
    }, incrementButtonAccessibilityProps, {
      children: _jsx(AddIcon, {
        fontSize: size == 'sm' ? 14 : 18,
        color: isIncrementDisabled ? colorTypes.disabledIconColor : colorTypes.color
      })
    }))]
  }));
};
CounterWidgetComponent.genericRendererKey = 'AirCounterWidget';